import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  public isSidebarFolded: boolean = true;

  private _sidebarUnfolded = new Subject<boolean>();
  public sidebarUnfolded$ = this._sidebarUnfolded.asObservable();

  private _closeAllSubmenus = new Subject<void>();
  public closeAllSubmenus$ = this._closeAllSubmenus.asObservable();

  private _closeSameLevelSubmenus = new Subject<string | null>();
  public closeSameLevelSubmenus$ = this._closeSameLevelSubmenus.asObservable();

  public foldSidebar(): void {
    this._sidebarUnfolded.next(true);
    this.isSidebarFolded = true;
  }

  public unfoldSidebar(): void {
    this._sidebarUnfolded.next(false);
    this.isSidebarFolded = false;
  }

  public closeAllSubmenus(): void {
    this._closeAllSubmenus.next();
  }

  public closeSameLevelSubmenus(parentMenuId: string | null): void {
    this._closeSameLevelSubmenus.next(parentMenuId);
  }
}
